import React from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Common from "../../../layouts/Common";
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import korms from '../../../assets/images/korms.jpeg';



const DigitalBirthCertificate = () => {
return (
<Common>
   <section className='sub-page-banner newsr-bg'>
      <Container>
         <Row>
            <Col md={12} className='text-center sup-page-inner'>
            <h2>Newsroom</h2>
            <Breadcrumb className='text-center custom-breadcrumb'>
               <Breadcrumb.Item>Home</Breadcrumb.Item>
               <Breadcrumb.Item>Newsroom</Breadcrumb.Item>
            </Breadcrumb>
            </Col>
         </Row>
      </Container>
   </section>
   <Container className='mb-5'>
      <Row className='column-reverse2'>
         <Col md={8} data-aos="fade-right">
         <div className='about-company mt-70 left-0'>
            <h5>ডিজিটাল জন্মনিবন্ধন নিয়ে কর্মশালা</h5>
            <span className='date-title'>Dated : 01 September, 2015</span>
            <p className='line-h'>
            গত ১লা সেপ্টেম্বর, ২০১৫ বিয়াম ফাউন্ডেশন, ঢাকায় প্ল্যান ইন্টারন্যাশনাল বাংলাদেশ ও এথিকস এডভান্স টেকনোলজি লিমিটেড ( ইএটিএল) এর যৌথ উদ্যোগে ডিজিটাল জন্ম নিবন্ধন বিষয়ক একটি কর্মশালা অনুষ্ঠিত হয়। জনাব নজরুল ইসলাম, সচিব (সমন্বয় ও পুনগর্ঠন), মন্ত্রিপরিষদ বিভাগ এই কর্মশালায় সভাপতিত্ব করেন। জন্ম নিবন্ধন প্রকল্পের প্রকল্প পরিচালক শেখ মুজিবুর রহমান, প্ল্যান ইন্টারন্যাশনাল বাংলাদেশের ডেপুটি কান্ট্রি ডিরেক্টর জনাব সৌম্য গুহ এবং ইএটিএল এর ব্যবস্থাপনা পরিচালক জনাব এমএ মুবিন খানসহ বিভিন্ন মন্ত্রণালয় ও উন্নয়ন সহযোগী প্রতিষ্ঠানের উর্ধ্বতন কর্মকর্তাগণ উপস্থিত ছিলেন। বাংলাদেশে সিভিল রেজিস্ট্রেশন এন্ড ভাইটাল স্ট্যাটিসটিক্স ( সিআরভিএস) এর কার্য়ক্রম শুরু হয়েছে। জন্ম নিবন্ধন কার্য়ক্রমকে সিআরভিএস এর সঙ্গে অধিকতর সম্পৃক্ত করার লক্ষে প্ল্যান বাংলাদেশ ইএটিএল এর সহযোগিতায় দেশে একটি জরিপ পরিচালনা করতে যাচ্ছে। কর্মশালায় জরিপের প্রশ্নপত্র পরিমার্জনসহ জন্ম নিবন্ধন ও সিআরভিএস এর সমন্বয় সাধনের বিষয়টিতে জোর দেয়া হয়। এই কর্মশালায় প্রাপ্ত মতামতের ভিত্তিতে সৃষ্ট প্রশ্নপত্রের মাধ্যমে আগামী ১৫ অক্টোবর, ২০১৫ পর্য়ন্ত ৭ টি বিভাগের ১৪ টি জেলায় ২৮ টি জরিপ এলাকায় ৩৫০০ টি পরিবারে জরিপ পরিচালনা করা হবে।
            </p>

            <p className='line-h'>
            এই জরিপের ফলে বাংলাদেশের ডিজিটাল জন্ম নিবন্ধন কার্য়ক্রমের উৎকর্ষতা বৃদ্ধি পাবে এবং ভবিষ্যতে সকল নাগরিকের সঠিক জন্ম তথ্য নিয়ে সিআরভিএস এর কার্য়ক্রম পরিচালিত হবে।
            </p>
         </div>
         </Col>
         <Col md={4} data-aos="fade-left">
         <img className='news-details' src={korms} alt="com" />
         </Col>
      </Row>

   </Container>
</Common>
);
};
export default DigitalBirthCertificate;